import constants from "../../core/constants";
import { toObject, parsePrice } from "../../core/utils";
import moment from "moment";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import reverse from "lodash/fp/reverse";

class CorporateInvoiceItemPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const formatDate = (item) => {
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      return item;
    };

    const formatAmount = (item) => {
      item.amount = parsePrice(item.amount);

      return item;
    };

    const formatNotes = (item) => {
      const namingFormat = (note) =>
        Object.assign(
          {},
          { comment: note.body, createdBy: note.operator },
          note
        );
      const formatDate = (note) => {
        note.createdAt = moment(note.createdAt.value).format(
          constants.dateTimeFormat
        );

        return note;
      };
      item.notes = reverse(
        map(flow([toObject, namingFormat, formatDate]))(item.notes)
      );

      return item;
    };

    const formatType = (item) => {
      item.type = item.type.name;

      return item;
    };

    return flow([formatDate, formatAmount, formatType, formatNotes])(data);
  }
}

export default CorporateInvoiceItemPageTransform;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoiceItem/corporateInvoiceItem.transforms.js